<template>
  <div class=" page-wrapper">
    <div class="heading-component">
      <HeadingVideoComponent/>
    </div>
    <div class="background-cta-main">
      <div class="index-specialties-offices  ">
        <div class="">
          <TitlesDescriptionComponent :description="titles.officesDescription"
                                      :placeholder="titles.officesPlaceholder"
                                      :placeholder-cta="openOfficesModal"
                                      :size="'medium'"
                                      :title="titles.officesTitle"/>
          <SelectedPostsGridCarousel :offices="offices"/>
        </div>
      </div>
    </div>

    <div class="">
      <IndexAboutComponent
          :buttonPlaceholder1="about.buttonPlaceholder1"
          :buttonPlaceholder2="about.buttonPlaceholder2"
          :description1="about.description1"
          :description2="about.description2"
          :specialists="specialists"
          :title1="about.title1"
          :title2="about.title2"
      >
        <template v-slot:logo-left>
          <UniHospitalLogoXL/>
        </template>
        <template v-slot:logo-right>
          <UniHospitalLogoNoTextXL/>
        </template>

      </IndexAboutComponent>
    </div>
    <div v-if="specialists">
      <IndexTeamComponent
          :buttonPlaceholder1="about.buttonPlaceholder1"
          :buttonPlaceholder2="about.buttonPlaceholder2"
          :description1="about.description1"
          :description2="about.description2"
          :specialists="specialists"
          :title1="about.title1"
          :title2="about.title2"/>
    </div>
    <div class="container-custom index-services-component">
      <div class="circle-text-decoration d-none">
        <CircleTextDecoration/>
      </div>
      <div v-if="false">
        <TitlesDescriptionComponent :description="titles.servicesDescription" :size="'medium'"
                                    :title="titles.servicesTitle"/>
        <div v-for="(category, index) in categories" :key="index" class="mt-3 mb-3">
          <router-link :to="{name: 'OneCategoryView', params: { id: category.id } }">
            <OneServiceCategoryButton :buttonIcon="category.icon" :buttonText="category.title"
                                      :buttonTextHover="$t('all-services')" :theme="'solid-white'"/>
          </router-link>
        </div>
        <div class="all-services-button">
          <router-link :to="{ name: 'ServicesView'}">
            <MainButton :button-text="$t('all-services')" :icon="'arrow-forward'" :size="'large'"
                        :theme="'solid-blue'"/>
          </router-link>
        </div>
      </div>

      <IndexImageCompareComponent :description="comparison.imageCompareDescription"
                                  :title="comparison.imageCompareTitle"/>
    </div>
    <div class="container-custom index-news-wrapper">
      <TitlesDescriptionComponent :button-text="titles.newsButtonText" :description="titles.newsDescription"
                                  :size="'medium'"
                                  :title="titles.newsTitle"/>
      <SelectedPostsGridCarousel :newsdata="news"/>
    </div>
    <div class="pop-up-modal-wrapper">
      <ModalPopUp ref="modalComponent" size="large" v-if="popUpModal.content">
        <img :src="'/storage/' + popUpModal.content.imageUrl[0]" alt="" class="pop-up-modal-image">
        <div class="pop-up-modal-content">
          <div class="pop-up-title">{{ popUpModal.content.title }}</div>
          <div class="pop-up-description" v-html="popUpModal.content.body"></div>

          <a :href="popUpModal.content.subTitle" class="d-flex justify-content-center">
            <div class="pop-up-button">
              <MainButton :button-text="$t('learn-more')" size="large" theme="solid-blue"/>
            </div>

          </a>
        </div>
      </ModalPopUp>
    </div>
  </div>
</template>

<script>
import HeadingVideoComponent from "@/components/Components/HeadingVideoComponent/HeadingVideoComponent.vue";
import TitlesDescriptionComponent
  from "@/components/Components/TitlesDescriptionComponent/TitlesDescriptionComponent.vue";
import IndexAboutComponent from "@/components/Components/IndexAboutComponent/IndexAboutComponent.vue";
import UniHospitalLogoXL from "@/components/Common/Icons/UniHospitalLogoXL.vue";
import UniHospitalLogoNoTextXL from "@/components/Common/Icons/UniHospitalLogoNoTextXL.vue";

import CircleTextDecoration from "@/components/Common/Icons/CircleTextDecoration.vue"
import IndexImageCompareComponent
  from "@/components/Components/IndexImageCompareComponent/IndexImageCompareComponent.vue";
import SelectedPostsGridCarousel from "@/components/Components/SelectedPostsGridCarousel/SelectedPostsGridCarousel.vue";
import OneServiceCategoryButton from "@/components/Common/Buttons/OneServiceCategoryButton.vue";
import MainButton from "@/components/Common/Buttons/MainButton.vue";
import IndexTeamComponent from "@/components/Components/IndexTeamComponent/IndexTeamComponent.vue";
import ModalPopUp from "@/components/Components/ModalMain/ModalPopUp.vue";

export default {
  components: {
    ModalPopUp,
    IndexTeamComponent,
    MainButton, OneServiceCategoryButton,
    IndexImageCompareComponent,
    UniHospitalLogoNoTextXL,
    UniHospitalLogoXL,
    HeadingVideoComponent,
    TitlesDescriptionComponent,
    IndexAboutComponent,
    CircleTextDecoration,
    SelectedPostsGridCarousel
  },

  data() {
    return {
      offices: [],
      about: {},
      categories: [],
      titles: {},
      news: null,
      comparison: {},
      specialists: null,
      modalComponent: null,
      popUpModal: {},
    };
  },
  async mounted() {
    const idsToFetch = ['86', '78', '98'];
    const teamResponse = await this.$store.dispatch("specialists/getSpecialistsByIds", idsToFetch);
    console.log(teamResponse); // Check if this logs the correct data
    this.specialists = teamResponse; // Ensure this assignment is pre sent
    this.offices = [
      {id: 61, title: this.$t('office-1'), number: '01', imgSrc: '/static/images/office-gyno.webp'},
      {id: 60, title: this.$t('office-2'), number: '02', imgSrc: '/static/images/office-cardio.webp'},
      {id: 57, title: this.$t('office-3'), number: '03', imgSrc: '/static/images/office-surgeon.webp'},
      {id: 56, title: this.$t('office-4'), number: '04', imgSrc: '/static/images/office-dermatology.webp'},
      {id: 67, title: this.$t('office-5'), number: '05', imgSrc: '/static/images/office-vascular-surgeon.webp'},
      {id: 55, title: this.$t('office-6'), number: '06', imgSrc: '/static/images/office-endocrinology.webp'},
    ];
    this.about = {
      title1: this.$t('index-about-title-1'),
      title2: this.$t('index-about-title-2'),
      description1: this.$t('index-about-description-1'),
      description2: this.$t('index-about-description-2'),
      buttonPlaceholder1: this.$t('index-about-placeholder-1'),
      buttonPlaceholder2: this.$t('index-about-placeholder-2'),
      imageDesktop: '/static/images/index-about-doctor-desktop.webp',
      imageMobile: '/static/images/index-about-doctor.webp',
      doctorTitle: this.$t('index-about-doctor-title'),
      doctorSubtitle: this.$t('index-about-doctor-subtitle')
    };
    this.categories = await this.$store.dispatch("categories/getCategories");
    this.categories = this.categories.slice(0, 5);
    this.comparison = {
      imageCompareTitle: this.$t('index-compare-title'),
      imageCompareDescription: this.$t('index-compare-description'),
    }
    this.titles = {
      officesTitle: this.$t('index-specialties-offices-title'),
      officesDescription: this.$t('index-specialties-offices-description'),
      officesPlaceholder: this.$t('index-specialties-offices-subtitle'),
      newsTitle: this.$t('index-news-title'),
      newsDescription: this.$t('index-news-description'),
      newsButtonText: this.$t('index-news-button'),
      servicesTitle: this.$t('index-services-title'),
      servicesDescription: this.$t('index-services-description'),
      servicesButtonText: this.$t('index-services-button'),

    };
    const response = await this.$store.dispatch("news/getNews");
    this.news = response.data;
    this.news = this.news.slice(0, 4);
    this.popUpModal = await this.$store.dispatch("homePopUpModal/getHomePopUpModal");
    setTimeout(() => {
      this.$refs.modalComponent?.showModal(); // Correct method to open the modal
    }, 1000);
  },
  methods: {
    async openOfficesModal() {
      await this.$store.dispatch("utils/toggleOfficesModal", true);
    }
  }
};

</script>

<style lang="scss" scoped>
@import "~@/assets/scss/fonts.scss";

.page-wrapper {
  font-family: $font-regular;
  overflow: hidden;

  .pop-up-modal-wrapper {
    position: relative;
    width: auto;

    .pop-up-modal-image {
      width: 100%;
    }

    .pop-up-modal-content {
      padding: 40px;
      font-family: $font-semi-bold;

      .pop-up-title {
        color: $color-brown;
        font-size: 22px;
        text-align: center;
        margin-bottom: $spacing-3;
      }

      .pop-up-button {
        min-width: 300px;
        margin-top: $spacing-3;

      }
    }
  }

  .background-cta-main {
    background: $color-cta-main;
  }

  .index-specialties-offices {
    border-bottom-left-radius: 50px;
    border-bottom-right-radius: 50px;
    background: $color-white;
    padding: $spacing-10 0 $spacing-10 10px;
  }

  .index-services-component {
    position: relative;
    background: $color-grey;
    border-radius: 30px;
    padding: 50px 10px;

  }

  .index-news-wrapper {
    padding: $spacing-7 0 $spacing-7 10px;
  }

  .all-services-button {
    max-width: 400px;
    margin: 60px 0;
  }


}


@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media screen and (min-width: 768px) {
  .page-wrapper {
    .index-specialties-offices {
      padding: 0 60px 100px;
    }

    .index-news-wrapper {
      padding: 0 60px $spacing-11;
    }

    .index-services-component {
      padding: 50px 60px 100px;
      border-radius: 50px;

      .circle-text-decoration {
        right: -5%;
        top: -12%;
        position: absolute;
        animation: rotate 25s linear infinite;
      }
    }

    .heading-component {
      padding: 15px 30px 0;

    }

    .all-services-button {
      max-width: 300px;
    }
  }


}
</style>